export default [
    {
        path: '/content/article',
        name: 'ContentArticle',
        component: () => import('@/pages/content/myContent/article/Article.vue'),
        meta: {
            title: '图文',
            requireAuth: true,
            authority: 'content:article'
        }
    },
    {
        path: '/content/article/add', 
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '新建图文',
            requireAuth: true,
            authority: 'content:article'
        }
    },
    {
        path: '/content/article/edit',
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '编辑图文',
            requireAuth: true,
            authority: 'content:article'
        }
    },
    {
        path: '/content/article/detail',
        name: 'DetailMyContent',
        component: () => import('@/pages/content/myContent/DetailMyContent.vue'),
        meta: {
            title: '图文详情',
            requireAuth: true,
            authority: 'content:article'
        },
        redirect: '/content/article/detail/report',
        children: [
            {
                path: 'report',
                name: 'StudyReport',
                component: () => import('@/pages/content/myContent/components/StudyReport.vue'),
                meta: {
                    title: '学情报告',
                    requireAuth: true,
                    authority: 'content:article'
                }
            },
        ]
    },

    {
        path: '/content/audio',
        name: 'ContentAudio',
        component: () => import('@/pages/content/myContent/audio/Audio.vue'),
        meta: {
            title: '音频',
            requireAuth: true,
            authority: 'content:audio'
        }
    },
    {
        path: '/content/audio/add', 
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '新建音频',
            requireAuth: true,
            authority: 'content:audio'
        }
    },
    {
        path: '/content/audio/edit',
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '编辑音频',
            requireAuth: true,
            authority: 'content:audio'
        }
    },
    {
        path: '/content/audio/detail',
        name: 'DetailMyContent',
        component: () => import('@/pages/content/myContent/DetailMyContent.vue'),
        meta: {
            title: '音频详情',
            requireAuth: true,
            authority: 'content:audio'
        },
        redirect: '/content/audio/detail/report',
        children: [
            {
                path: 'report',
                name: 'StudyReport',
                component: () => import('@/pages/content/myContent/components/StudyReport.vue'),
                meta: {
                    title: '学情报告',
                    requireAuth: true,
                    authority: 'content:audio'
                }
            },
        ]
    },

    {
        path: '/content/video',
        name: 'ContentVideo',
        component: () => import('@/pages/content/myContent/video/Video.vue'),
        meta: {
            title: '视频',
            requireAuth: true,
            authority: 'content:video'
        }
    },
    {
        path: '/content/video/add', 
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '新建视频',
            requireAuth: true,
            authority: 'content:video'
        }
    },
    {
        path: '/content/video/edit',
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '编辑视频',
            requireAuth: true,
            authority: 'content:video'
        }
    },
    {
        path: '/content/video/detail',
        name: 'DetailMyContent',
        component: () => import('@/pages/content/myContent/DetailMyContent.vue'),
        meta: {
            title: '视频详情',
            requireAuth: true,
            authority: 'content:video'
        },
        redirect: '/content/video/detail/report',
        children: [
            {
                path: 'report',
                name: 'StudyReport',
                component: () => import('@/pages/content/myContent/components/StudyReport.vue'),
                meta: {
                    title: '学情报告',
                    requireAuth: true,
                    authority: 'content:video'
                }
            },
            
        ]
    },

    {
        path: '/content/myColumn',
        name: 'ColumnList',
        component: () => import('@/pages/content/myColumn/MyColumn.vue'),
        meta: {
            title: '专栏',
            requireAuth: true,
            authority: 'content:myColumn'
        }
    },
    {
        path: '/content/myColumn/add',
        name: 'AddColumn',
        component: () => import('@/pages/content/myColumn/Add.vue'),
        meta: {
            title: '新增专栏',
            requireAuth: true,
            authority: 'content:myColumn'
        }
    },
    {
        path: '/content/myColumn/edit',
        name: 'EditColumn',
        component: () => import('@/pages/content/myColumn/Edit.vue'),
        meta: {
            title: '编辑专栏',
            requireAuth: true,
            authority: 'content:myColumn'
        }
    },
    {
        path: '/content/myColumn/detail',
        name: 'DetailColumn',
        component: () => import('@/pages/content/myColumn/Detail.vue'),
        meta: {
            title: '专栏详情',
            requireAuth: true,
            authority: 'content:myColumn'
        },
        redirect: '/content/myColumn/detail/contentManage',
        children: [
            {
                path: 'contentManage',
                name: 'ColumnContentManage',
                component: () => import('@/pages/content/myColumn/detail/content/ContentList.vue'),
                meta: {
                    title: '内容管理',
                    requireAuth: true,
                    authority: 'content:myColumn'
                }
            },
            {
                path: 'studyReport',
                name: 'ColumnStudyReport',
                component: () => import('@/pages/content/myColumn/detail/report/StudyReport.vue'),
                meta: {
                    title: '学情报告',
                    requireAuth: true,
                    authority: 'content:myColumn'
                }
            },
        ]
    },
    {
        path: '/content/myColumn/content/detail',
        name: 'ColumnLessonDetail',
        component: () => import('@/pages/content/myColumn/detail/content/DetailColumnLesson.vue'),
        meta: {
            title: '专栏课详情',
            requireAuth: true,
            authority: 'content:myColumn'
        }
    },
    {
        path: '/content/myColumn/content/add',
        name: 'RedactMyColumn',
        component: () => import('@/pages/content/myColumn/detail/content/RedactMyColumn.vue'),
        meta: {
            title: '新增专栏内容',
            requireAuth: true,
            authority: 'content:myColumn'
        }
    },
    {
        path: '/content/myColumn/content/edit',
        name: 'RedactMyColumn',
        component: () => import('@/pages/content/myColumn/detail/content/RedactMyColumn.vue'),
        meta: {
            title: '编辑专栏内容',
            requireAuth: true,
            authority: 'content:myColumn'
        }
    },

    {
        path: '/content/alive',
        name: 'ContentALive',
        component: () => import('@/pages/content/myContent/alive/ALive.vue'),
        meta: {
            title: '直播',
            requireAuth: true,
            authority: 'content:alive'
        }
    },
    {
        path: '/content/alive/add', 
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '新建直播',
            requireAuth: true,
            authority: 'content:alive'
        }
    },
    {
        path: '/content/alive/edit',
        name: 'RedactMyContent',
        component: () => import('@/pages/content/myContent/RedactMyContent.vue'),
        meta: {
            title: '编辑直播',
            requireAuth: true,
            authority: 'content:alive'
        }
    },
    {
        path: '/content/alive/detail',
        name: 'LiveDetail',
        component: () => import('@/pages/content/myContent/alive/Detail.vue'),
        meta: {
            title: '直播详情',
            requireAuth: true,
            authority: 'content:alive'
        },
        redirect: '/content/alive/detail/student',
        children: [
            {
                path: 'student',
                name: 'StudentList',
                component: () => import('@/pages/content/myContent/alive/components/StudentList.vue'),
                meta: {
                    title: '学员名单',
                    requireAuth: true,
                    authority: 'content:alive'
                }
            },
            {
                path: 'replay',
                name: 'TeacherList',
                component: () => import('@/pages/content/myContent/alive/components/ReplaySetting.vue'),
                meta: {
                    title: '回放设置',
                    requireAuth: true,
                    authority: 'content:alive'
                }
            },
            {
                path: 'retweet',
                name: 'TeacherList',
                component: () => import('@/pages/content/myContent/alive/components/RetweetSetting.vue'),
                meta: {
                    title: '转播设置',
                    requireAuth: true,
                    authority: 'content:alive'
                }
            },
            {
                path: 'teacher',
                name: 'TeacherList',
                component: () => import('@/pages/content/myContent/alive/components/TeacherList.vue'),
                meta: {
                    title: '讲师名单',
                    requireAuth: true,
                    authority: 'content:alive'
                }
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/router/module/content.js